// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".min-h-scroll[data-v-5662e4ca]{height:calc(100vh - 149px);overflow-y:scroll}.mb-20[data-v-5662e4ca]{padding-bottom:62px}.border-outline[data-v-5662e4ca]{border:none;outline:.5px solid rgba(0,0,0,.12)!important}.light[data-v-5662e4ca]{-webkit-filter:grayscale(100%) brightness(1000%);filter:grayscale(100%) brightness(1000%)}", ""]);
// Exports
module.exports = exports;
